function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-content: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import throttle from 'lodash.throttle';
import { cacheFileGet, cacheFileSet, cacheFileDel, cacheFileStoreKeyByUrl } from './cache';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css'; // See : https://github.com/wojtekmaj/react-pdf#browserify-and-others

import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var PdfWrapper = styled.div(_templateObject());
export var fetchBackgroundBase64 = function fetchBackgroundBase64(_ref) {
  var _ref$media = _ref.media,
      url = _ref$media.url,
      width = _ref$media.width,
      height = _ref$media.height,
      mime = _ref$media.mime,
      force = _ref.force;
  return new Promise(function (resolve, reject) {
    var key = cacheFileStoreKeyByUrl(url);
    cacheFileGet(key).then(function (val) {
      var useFetch = true;

      if (!force && val !== undefined) {
        var obj = JSON.parse(val);

        if (obj) {
          useFetch = false;
          obj.cached = true;
          resolve(obj);
        }
      }

      if (useFetch) {
        fetch(url).then(function (response) {
          return response.blob();
        }).then(function (blob) {
          var reader = new FileReader();

          reader.onload = function () {
            var obj = {
              url: url,
              width: parseFloat(width),
              height: parseFloat(height),
              mime: mime,
              key: key,
              time: new Date(),
              base64: this.result,
              cached: false
            };
            cacheFileSet(key, JSON.stringify(obj));
            resolve(obj);
          };

          reader.readAsDataURL(blob);
        })["catch"](function (e) {
          return reject(e);
        });
      }
    });
  });
};
export var PdfField = /*#__PURE__*/function (_Component) {
  _inherits(PdfField, _Component);

  var _super = _createSuper(PdfField);

  function PdfField(_props) {
    var _this;

    _classCallCheck(this, PdfField);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      numPages: null,
      width: 100,
      loading: true,
      error: true,
      media: null,
      remoteFetched: false
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      window.addEventListener("resize", _this.setDivSize);

      _this.loadMedia(_this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (JSON.stringify(_this.props.media) !== JSON.stringify(prevProps.media)) {
        _this.loadMedia(_this.props);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
      window.removeEventListener("resize", _this.setDivSize);
    });

    _defineProperty(_assertThisInitialized(_this), "loadMedia", function (props) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var media = props.media,
          startLoading = props.startLoading,
          stopLoading = props.stopLoading;

      if (_this._isMounted) {
        _this.setDivSize();

        if (startLoading) {
          startLoading();
        }

        fetchBackgroundBase64({
          media: media,
          force: force
        }).then(function (media) {
          if (_this._isMounted) {
            _this.setState({
              media: media,
              loading: false
            });

            if (stopLoading) {
              stopLoading();
            }

            _this.setDivSize();
          }
        })["catch"](function (e) {
          if (_this._isMounted) {
            _this.onLoadError();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setDivSize", throttle(function () {
      var media = _this.state.media;

      if (_this._isMounted && _typeof(_this.pdfRef.current) !== undefined && _this.pdfRef.current) {
        _this.pdfRef.current.style.width = '100%';
        _this.pdfRef.current.style.height = '100%';

        if (_this.props.onResize) {
          _this.props.onResize({
            width: null,
            height: null
          });
        }

        var outBCR = _this.pdfRef.current.getBoundingClientRect();

        var size = {
          width: outBCR.width,
          height: outBCR.height
        };
        var sizeRef = {
          width: outBCR.width,
          height: outBCR.height
        }; // console.log('outBCR', size);

        if (media && media.hasOwnProperty('width') && media.width > 0 && media.height > 0) {
          sizeRef = {
            width: parseFloat(media.width),
            height: parseFloat(media.height)
          }; // console.log('media', sizeRef);
        } else if (_this.myPage) {
          var pageBCR = _this.myPage.getBoundingClientRect();

          sizeRef = {
            width: pageBCR.width,
            height: pageBCR.height
          };
          var key = cacheFileStoreKeyByUrl(media.url); // Update values

          cacheFileGet(key).then(function (val) {
            if (val !== undefined) {
              var obj = JSON.parse(val);
              obj.width = sizeRef.width;
              obj.height = sizeRef.height;
              cacheFileSet(key, JSON.stringify(obj));

              if (_this._isMounted) {
                _this.setState({
                  media: obj
                });
              }
            }
          }); // console.log('pageBCR', sizeRef, this.myPage);
        } // Preserve Ratio


        size.width = sizeRef.width * outBCR.height / sizeRef.height;
        size.height = outBCR.height; // console.log('computed', size, outBCR);

        if (outBCR.width < size.width) {
          size.width = outBCR.width;
          size.height = sizeRef.height * outBCR.width / sizeRef.width;
        }

        size.width = size.width - 1;
        size.height = size.height - 1; // console.log('computed final', size);

        if (_this.props.onResize) {
          _this.props.onResize(size);
        }

        _this.setState({
          width: size.width
        });
      }
    }, 100));

    _defineProperty(_assertThisInitialized(_this), "onLoadSuccess", function () {
      if (_this._isMounted) {
        _this.setDivSize();

        if (_this.props.stopLoading) {
          _this.props.stopLoading();
        }

        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadError", function () {
      var media = _this.state.media;

      if (_this._isMounted && media) {
        var key = cacheFileStoreKeyByUrl(media.url);
        cacheFileDel(key);

        if (media.cached) {
          _this.loadMedia(_this.props, true);
        } else {
          _this.setState({
            error: true
          });
        }
      } else {
        _this.setState({
          error: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pdfLoading", function () {
      var loader = _this.props.loader;
      return loader ? loader : /*#__PURE__*/React.createElement("div", null);
    });

    _this.pdfRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(PdfField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          width = _this$state.width,
          media = _this$state.media,
          loading = _this$state.loading,
          error = _this$state.error;
      var _this$props = this.props,
          pageNumber = _this$props.pageNumber,
          loadingMessage = _this$props.loadingMessage,
          errorMessage = _this$props.errorMessage;
      return /*#__PURE__*/React.createElement(PdfWrapper, {
        ref: this.pdfRef
      }, loading ? loadingMessage ? loadingMessage : null : media && media.hasOwnProperty('base64') ? /*#__PURE__*/React.createElement(Document, {
        file: media.base64 // onLoadSuccess={this.onLoadSuccess}
        ,
        onLoadError: this.onLoadError,
        externalLinkTarget: '_blank',
        loading: this.pdfLoading()
      }, /*#__PURE__*/React.createElement(Page, {
        pageNumber: pageNumber,
        width: width,
        inputRef: function inputRef(ref) {
          _this2.myPage = ref;
        },
        onRenderSuccess: this.onLoadSuccess,
        onLoadError: this.onLoadError,
        onRenderError: this.onLoadError
      })) : error && errorMessage ? errorMessage : /*#__PURE__*/React.createElement("div", null, "ERROR"));
    }
  }]);

  return PdfField;
}(Component);
PdfField.propTypes = {
  media: PropTypes.object.isRequired,
  startLoading: PropTypes.func,
  stopLoading: PropTypes.func
};
PdfField.defaultProps = {
  pageNumber: 1,
  media: {}
};
export default PdfField;